import React, { ReactNode } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

interface Props {
    title?: ReactNode;
    onClose?: () => void;
    children: ReactNode;
}

export default function SidePanel({ title, onClose, children }: Props) {
    return (
        <div className="flex h-full flex-col">
            <header className="flex items-center justify-between border-b border-border px-5 py-4">
                <div className="min-w-0 truncate pr-2 text-sm font-medium text-ink">{title}</div>
                {onClose && (
                    <button
                        type="button"
                        onClick={onClose}
                        aria-label="close"
                        className="flex h-8 w-8 shrink-0 appearance-none items-center justify-center rounded-full! border-0 bg-transparent p-0 text-ink-muted hover:bg-surface-3 hover:text-ink"
                    >
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                )}
            </header>
            <div className="flex-1 overflow-auto px-5 py-4">{children}</div>
        </div>
    );
}
